<template>
	<div class="pay_status">
		<template v-if="network_success">
			<div class="hd">
				<div class="box">
					<h1 v-if="status == 1">订单已完成</h1>
					<h1 v-if="status == 2 || status == 3">支付失败</h1>
					<h4 v-if="status == 1">订单完成</h4>
					<h4 v-if="status == 2">订单待支付</h4>
					<h4 v-if="status == 3">订单未支付</h4>
				</div>
			</div>
			<div class="main_box">
				<div class="icon_box">
					<i v-if="status == 1" class="success_icon"></i>
					<i v-if="status == 2" class="fail_icon"></i>
					<i v-if="status == 3" class="fail_icon"></i>
				</div>
				<p v-if="status == 1" class="desc">恭喜你！该增值服务套餐，你已购买完成！</p>
				<div class="btns">
					<button class="home_btn text_theme" @click="ToHome">主页</button>
					<button class="continue_btn" @click="ToService">继续浏览</button>
				</div>
			</div>
		</template>
		
		<!-- 网络出错 -->
		<network-err v-if="!network_success" @onRefresh="handleNetworkRefresh"></network-err>
		<!-- 网络出错 end -->
	</div>
</template>

<script>
	import Api from '../../api/api.js';
	import { mapMutations } from 'vuex';
	
	export default {
		mounted() {
			this.timeSimp = this.$route.query.time;
			this.getData();
		},
		data() {
			return {
				network_success: true,
				status: 1	// 1:支付成功；2:待支付；3:没有扫码
			}
		},
		methods: {
			/****************** @Function ***********************/
			// 网络错误刷新
			handleNetworkRefresh() {
				this.getData();
			},
			// 返回主页
			ToHome() {
				this.$router.replace({path: '/index/home'});
			},
			// 继续浏览
			ToService() {
				this.$router.replace({path: '/index/service'});
			},
			
			/****************** @Function ***********************/
			// 获取数据
			getData() {
				const that = this;
				that.setLoading(true);
				let requestData = {
					uuid: this.timeSimp
				};
				Api.getPayStatus(requestData).then((res) => {
					if (res.data.success) {
						that.setLoading(false);
						that.network_success = true;
						res.data.data
						? (that.status = res.data.data.payStatus)
						: (that.status = 3);
					} else {
						that.setLoading(false);
						that.network_success = false;
					}
				}, () => {
					that.setLoading(false);
					that.network_success = false;
				});
			},
			
			...mapMutations({
				'setLoading': 'setLoading'
			})
		}
	}
</script>

<style scoped>
	.pay_status .hd{ height: 270px;background: #2b2b2b;color: #fff;text-align: center; }
	.pay_status .hd .box{ width: 1200px;margin: 0 auto;padding: 78px 0 0 0; }
	.pay_status .hd h1{ font-size: 66px;line-height: 74px; }
	.pay_status .hd h4{ font-size: 18px;line-height: 40px; }
	.pay_status .main_box{ width: 1200px;margin: 0 auto;padding: 60px 0 125px 0; }
	.pay_status .icon_box{ width: 370px;height: 294px;margin: 0 auto;padding: 70px 0 0 0;border: 1px solid #2b53c6; }
	.pay_status .icon_box .success_icon{ display: block;width: 155px;height: 155px;margin: 0 auto;background-image: url(../../assets/pay_success.png); }
	.pay_status .icon_box .fail_icon{ display: block;width: 155px;height: 155px;margin: 0 auto;background-image: url(../../assets/pay_fail.png); }
	.pay_status .main_box .desc{ margin-top: 45px;font-size: 30px;color: #333;text-align: center;line-height: 46px; }
	.pay_status .btns{ margin-top: 55px;text-align: center;font-size: 16px; }
	.pay_status .home_btn{ width: 158px;height: 50px;border: 1px solid #2b53c6;background: #fff; }
	.pay_status .continue_btn{ width: 230px;height: 50px;margin-left: 15px;color: #fff; }
</style>
